import { mergeWith } from "lodash";
import { AppConfig } from "types/appFunctionality";
import audience from "config/appConfigFiles/audience.json";

export function isAudienceLink(search: string): boolean {
  return new URLSearchParams(search).has("audience");
}

/** Apply last: profile and resource roles cannot enable audience mutations. */
export function restrictAudienceConfig(config: AppConfig): AppConfig {
  return mergeWith({}, config, audience,
    (_previous: unknown, next: unknown) => Array.isArray(next) ? next : undefined) as AppConfig;
}

/** Reject domain mutations while the application is in audience mode. */
export function assertAudienceMutationAllowed(isAudience: boolean): void {
  if (isAudience) throw new Error("audience-read-only");
}

/** Retain link identity through route-guard redirects so reload remains read-only. */
export function preserveAudienceLink(path: string, search: string): string {
  return isAudienceLink(search) ? `${path}${search}` : path;
}

export function getLogoutPath(search: string): string {
  if (!isAudienceLink(search)) return "/login";
  const parameters = new URLSearchParams(search);
  parameters.set("page", "map-page");
  return `/anonymous-login?${parameters.toString()}`;
}
